import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLanguage } from '../helpers/localStorageHelper';

import enCommon from './en/_common.json';
import enError from './en/_error.json';
import enAuth from './en/_auth.json';
import enWidget from './en/_widget.json';
import enNav from './en/_nav.json';
import enStepper from './en/_stepper.json';
import enSiteList from './en/_siteList.json';
import enCarousel from './en/_carousel.json';
import enDashboard from './en/_dashboard.json';
import enChart from './en/_chart.json';
import enProgressBars from './en/_progressBars.json';
import enReported from './en/_reported.json';
import enReportIssue from './en/_reportIssue.json';
import enMyReports from './en/_myReports.json';
import enIssueAdded from './en/_issueAdded.json';
import enAccessibilityDashboard from './en/_accessibilityDashboard.json';
import enManualAudit from './en/_manualAudit.json';
import enAutomatedReports from './en/_automatedReports.json';
import enAccount from './en/_account.json';
import enFaq from './en/_faq.json';
import enSupport from './en/_support.json';
import enReports from './en/_reports.json';
import enUsers from './en/_users.json';
import enIssue from './en/_issue.json';
import enSitemap from './en/_sitemap.json';
import enOrganization from './en/_organization.json';
import enScanPage from './en/_scanPage.json';
import uaAuth from './ua/_auth.json';
import uaWidget from './ua/_widget.json';
import uaNav from './ua/_nav.json';
import uaCommon from './ua/_common.json';
import uaCarousel from './ua/_carousel.json';
import uaDashboard from './ua/_dashboard.json';
import uaError from './ua/_error.json';
import uaStepper from './ua/_stepper.json';
import uaSiteList from './ua/_siteList.json';
import uaChart from './ua/_chart.json';
import uaProgressBars from './ua/_progressBars.json';
import uaReported from './ua/_reported.json';
import uaMyReports from './ua/_myReports.json';
import uaAccessibilityDashboard from './ua/_accessibilityDashboard.json';
import uaManualAudit from './ua/_manualAudit.json';
import uaAutomatedReports from './ua/_automatedReports.json';
import uaAccount from './ua/_account.json';
import uaFaq from './ua/_faq.json';
import uaSupport from './ua/_support.json';
import uaReports from './ua/_reports.json';
import uaUsers from './ua/_users.json';
import uaIssue from './ua/_issue.json';
import uaReportIssue from './ua/_reportIssue.json';
import uaSitemap from './ua/_sitemap.json';
import uaOrganization from './ua/_organization.json';
import uaScanPage from './ua/_scanPage.json';
const currentLanguage = getLanguage();

const resources = {
  en: {
    common: enCommon,
    error: enError,
    auth: enAuth,
    widget: enWidget,
    nav: enNav,
    stepper: enStepper,
    siteList: enSiteList,
    carousel: enCarousel,
    dashboard: enDashboard,
    chart: enChart,
    progressBars: enProgressBars,
    reported: enReported,
    reportIssue: enReportIssue,
    myReports: enMyReports,
    issueAdded: enIssueAdded,
    accessibilityDashboard: enAccessibilityDashboard,
    manualAudit: enManualAudit,
    automatedReports: enAutomatedReports,
    account: enAccount,
    faq: enFaq,
    support: enSupport,
    reports: enReports,
    users: enUsers,
    issue: enIssue,
    sitemap : enSitemap,
    organization : enOrganization,
    scanPage : enScanPage

  } as const,
  ua: {
    auth: uaAuth,
    widget: uaWidget,
    nav: uaNav,
    common: uaCommon,
    carousel: uaCarousel,
    dashboard: uaDashboard,
    error: uaError,
    stepper: uaStepper,
    siteList: uaSiteList,
    chart: uaChart,
    progressBars: uaProgressBars,
    reported: uaReported,
    myReports: uaMyReports,
    accessibilityDashboard: uaAccessibilityDashboard,
    manualAudit: uaManualAudit,
    automatedReports: uaAutomatedReports,
    account: uaAccount,
    faq: uaFaq,
    support: uaSupport,
    reports: uaReports,
    users: uaUsers,
    issue: uaIssue,
    reportIssue: uaReportIssue,
    Sitemap : uaSitemap,
    organization : uaOrganization,
    scanPage : uaScanPage

  } as const,
};

i18n.use(initReactI18next).init({
  resources,
  lng: currentLanguage ? currentLanguage : 'en',
});

i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
});

interface ILanguageData {
  value: string;
  label: string;
}

export const getLanguageData = (): ILanguageData[] => [
  {
    value: 'en',
    label: i18n.t('common:english'),
  },
  {
    value: 'ua',
    label: i18n.t('common:ukrainian'),
  },
];

export default i18n;
